// extracted by mini-css-extract-plugin
module.exports = {"practiceTestHome":"PracticeTestHome_practiceTestHome__5Btph","container":"PracticeTestHome_container__1Bt3H","scheduleHeader":"PracticeTestHome_scheduleHeader__3q-5y"};